if (!window.__dbaBuyNowInit) {
  window.__dbaBuyNowInit = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-buy-now-button]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const form = button.closest('form');
    if (!form) return;

    button.disabled = true;
    button.classList.add('loading');

    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart-add-failed');
        window.location.href = `${window.shopUrl}/checkout`;
      })
      .catch(() => {
        button.disabled = false;
        button.classList.remove('loading');
        form.requestSubmit();
      });
  });
}
